import { useEffect, useState } from "react";

import { useConfig } from "@jti/app-context/useConfig";
import { Button } from "@jti/core-components/components/Button";
import { AUTH_ROUTE_PATHS } from "@jti/fe-common/routes/auth-routes";
import { useAuthHrefResolver } from "@jti/ui/providers/AuthRoutingProvider";
import { useTranslations } from "@jti/ui/providers/useTranslations";

import { PROMO_BUTTON_TYPE } from "@product-details/hooks/useSpecialPromo";

import styles from "./AddProductButton.module.scss";

type SelectedPromoButtonType = { type: PROMO_BUTTON_TYPE.LOGIN | PROMO_BUTTON_TYPE.SIMILAR_PRODUCTS };

export const PromoButton = ({ type }: SelectedPromoButtonType) => {
  const { __ } = useTranslations();
  const [authWithPDPBackUrl, setAuthWithPDPBackUrl] = useState("");
  const config = useConfig();
  const resolveAuthHref = useAuthHrefResolver();

  useEffect(() => {
    const currentPathName = window.location.pathname;
    setAuthWithPDPBackUrl(resolveAuthHref({ route: AUTH_ROUTE_PATHS.login, search: { returnUrl: currentPathName } }));
  }, [resolveAuthHref]);

  const buttonContent = {
    [PROMO_BUTTON_TYPE.LOGIN]: {
      href: authWithPDPBackUrl,
      text: __("com.product.login_button_label"),
    },
    [PROMO_BUTTON_TYPE.SIMILAR_PRODUCTS]: {
      href: config.SHOP_URL,
      text: __("com.product.similar_products_button_label"),
    },
  };

  const { href, text } = buttonContent[type] ?? {};

  if (!href || !text) return null;

  return (
    <div className={styles.addProductButtonWrapper} data-testid="promo-button">
      <Button href={href} nativeBehaviour>
        {text}
      </Button>
    </div>
  );
};
